import * as React from 'react'
import { buttonVariants, type ButtonVariantProps } from './Button.variants'
import { cn } from '../../utils/cn'

type ButtonOwnProps<T extends React.ElementType> = ButtonVariantProps & {
  as?: T | undefined
  className?: string | undefined
}

export type ButtonProps<T extends React.ElementType = 'button'> = ButtonOwnProps<T> &
  Omit<React.ComponentPropsWithoutRef<T>, keyof ButtonOwnProps<T>>

export default function Button<T extends React.ElementType = 'button'>({
  as,
  variant,
  size,
  className,
  ...rest
}: ButtonProps<T>) {
  const Component = (as ?? 'button') as React.ElementType
  return <Component className={cn(buttonVariants({ variant, size }), className)} {...rest} />
}
